import { useState, useMemo, useRef } from "react"
import { useRequest } from "ahooks";
import { Card, Button, message } from "antd";
import { Table } from "./../../../components/table";
import { generateTableColumns, generateLanguageTableColumns } from "./config";
import { SettingsServer } from "./../../../server";
import { Operation } from "./operation";
import { langCommon } from "../../../locales";
import { ViewModal } from "./view";

import "./index.scss";

const server = SettingsServer.Notice

export const Notice = () => {
    const operationRef: any = useRef();
    const viewRef: any = useRef();

    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);

    //获取表格数据
    const { refresh } = useRequest(server.list, {
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => setTableData([]),
        onSuccess: (res: any) => {
            setTableData(res);
        }
    });

    const { run: deleteData } = useRequest(server.delete, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onSuccess: () => {
            message.success(langCommon?.deleteSuccess);
            refresh();
        }
    });

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ deleteData, operationRef, loading, setLoading, refresh });
    }, [deleteData, operationRef, loading, setLoading, refresh]);

    const getLanguageTableColumns = useMemo(() => {
        return generateLanguageTableColumns({ viewRef });
    }, [viewRef]);

    return (
        <div>
            <Card>
                <div className="flex flex-end mb20">
                    <Button className="ml10" type="primary" onClick={() => operationRef.current?.changeVisible(true, 'create')}>{langCommon?.create}</Button>
                </div>
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    className="notice-table"
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={false}
                    expandable={{
                        expandedRowRender: (record: any) => {
                            return <div style={{ background: '#B9DEF0', padding: 20 }}>
                                <Table
                                    style={{ borderRadius: 8, overflow: "hidden" }}
                                    size="small"
                                    dataSource={record.NoticeLanguages}
                                    columns={getLanguageTableColumns}
                                    rowKey="Id"
                                    align="center"
                                    scroll={{
                                        x: 'max-content'
                                    }}
                                    page={false}
                                />
                            </div>
                        },
                    }}
                />
            </Card >
            <Operation ref={operationRef} onSuccess={refresh} />
            <ViewModal ref={viewRef} />
        </div>
    );
}